<script>

    import { replace } from 'svelte-spa-router'
    import { adminStore } from '../stores'
    import { isPermission } from '../$methods/permissions.methods'

    import View from '../$layouts/view.layout.svelte'
    import PageHeader from '../$components/page.header.svelte'
    import Modal from '../$components/modal.container.svelte'

    import Prices from './component.prices.svelte'
    import Price from './component.price.svelte'
    import Update from './component.update.svelte'
    import Create from './component.create.svelte'

    if(!isPermission($adminStore, 'UsersView.Prices.View'))
        replace('/404')

</script>

<View>
    <PageHeader title="Precios" subtitle="Tarifas y precios de envío" />
    <Prices />
</View>

<Modal id="price_modal" title="Información">
    <Price />
</Modal>

<Modal id="price_create_modal" title="Crear precio">
    <Create />
</Modal>

<Modal id="price_update_modal" title="Actualizar">
    <Update />
</Modal>
